import { GET_USER, CLEAR_USER_ERROR } from './constants/actionTypes'
import fusionAPI from './api/fusionApi'
import Axios from 'axios'
export const getUser = (payload) => ({
    type: GET_USER.default,
    payload,
})

export const getUserGoogleAuth = (payload) => ({
    type: GET_USER.fulfilled,
    payload,
})

export const clearUserError = () => ({
    type: CLEAR_USER_ERROR.default,
})

export const clearUserErrorBoundActionCreator = () => async (dispatch) => {
    dispatch(clearUserError())
}

export const getUserBoundActionCreator = (loginDetails) => async (dispatch) => {
    try {
        const requestPayload = {
            loginId: loginDetails.email,
            password: loginDetails.password,
            applicationId: `${process.env.REACT_APP_FUSION_APP_ID}`,
        }

        const payload = fusionAPI.login(requestPayload)

        await dispatch(getUser(payload))
    } catch (error) {
        const { exception } = error
        console.log({ exception })
    }
}

export const resendVerificationEmail = (email) => {
    const TENANT_ID = `${process.env.REACT_APP_FUSION_TENANT_ID}`
    const params = new URLSearchParams()
    params.append('email', email)
    return Axios({
        url: `https://auth.coinprofile.co/api/user/verify-email?${params.toString()}`,
        method: 'PUT',
        headers: {
            'X-FusionAuth-TenantId': TENANT_ID,
        },
    })
}

export default getUserBoundActionCreator
